import PropTypes from "prop-types";
import React from "react";
import classes from "./Unveil.scss";
import AnimateHeight from "UIComponents/AnimateHeight";
import I18nHOC from "UIComponents/I18nHOC";
import { onEnterOrSpaceKeyDown } from "Utils";
import classNames from "classnames";
class Unveil extends React.PureComponent {
  constructor(props) {
    super(props);
    this.state = {
      collapsed: props.collapsed,
      showCollapse: false,
    };
  }
  componentDidMount = () => {
    if (this.contentRef) {
      this.showCollapseHeight({ contentRef: this.contentRef });
    }
  };

  componentDidUpdate = () => {
    const { updateHeightOnComponentUpdate } = this.props;
    if (this.contentRef && updateHeightOnComponentUpdate) {
      this.showCollapseHeight({
        contentRef: this.contentRef,
      });
    }
  };

  showCollapseHeight = ({ contentRef }) => {
    const { maxHeight, hideCollapseHeight } = this.props;
    if (!hideCollapseHeight) {
      setTimeout(() => {
        this.setState({
          showCollapse: contentRef.clientHeight > maxHeight,
        });
      }, 50);
    }
  };

  toggleCollapsed = e => {
    e.stopPropagation();
    const { onToggleCollapse } = this.props;
    if (onToggleCollapse) {
      onToggleCollapse(e);
    } else {
      this.setState(prevState => ({ collapsed: !prevState.collapsed }));
    }
  };

  getHeight = () => {
    const { collapsed, showCollapse } = this.state;
    const { maxHeight } = this.props;

    if (showCollapse) {
      return collapsed ? maxHeight : "auto";
    }

    return "auto";
  };

  onAnimationStart = () => {
    const { onAnimationStart } = this.props;
    if (onAnimationStart) {
      onAnimationStart();
    }
  };

  onAnimationEnd = () => {
    const { onAnimationEnd } = this.props;
    if (onAnimationEnd) {
      onAnimationEnd();
    }
  };

  render() {
    const {
      children,
      animateOpacity,
      containerStyle,
      animateHeightStyle,
      collapseTextStyle,
      collapseTextExpand,
      collapseTextShrink,
      t,
      collapseTextLocalesOptions,
      testId,
      animationDuration,
      inlineReadMore,
    } = this.props;
    const { collapsed, showCollapse } = this.state;

    const height = this.getHeight();

    const containerClasses = classNames({
      [classes.container]: !inlineReadMore,
      [classes.inlineContainer]: inlineReadMore,
    });

    const collapseTextClasses = classNames({
      [classes.collapseText]: !inlineReadMore,
      [classes.collapseTextInline]: inlineReadMore,
      [classes.collapseTextInlineReadMore]: inlineReadMore && collapsed,
    });

    return (
      <div className={containerClasses} style={containerStyle}>
        <AnimateHeight
          height={height}
          duration={animationDuration}
          onAnimationStart={this.onAnimationStart}
          onAnimationEnd={this.onAnimationEnd}
          animateOpacity={animateOpacity}
          style={animateHeightStyle}
          customRef={ref => (this.animateHeightChildrenWrapper = ref)}
        >
          <div ref={ref => (this.contentRef = ref)}>{children}</div>
        </AnimateHeight>
        {showCollapse && (
          <div
            className={collapseTextClasses}
            onClick={this.toggleCollapsed}
            style={collapseTextStyle}
            data-test-id={`${testId}-collapseText-showMore`}
            tabIndex={0}
            onKeyDown={e => onEnterOrSpaceKeyDown(e, this.toggleCollapsed)}
          >
            {collapsed
              ? t(collapseTextExpand, collapseTextLocalesOptions)
              : t(collapseTextShrink)}
          </div>
        )}
      </div>
    );
  }
}

Unveil.defaultProps = {
  maxHeight: 188,
  animateOpacity: true,
  containerStyle: {},
  animateHeightStyle: {},
  collapseTextStyle: {},
  collapseTextExpand: "common:see_more_noDots",
  collapseTextShrink: "common:see_less_noDots",
  collapsed: true,
  updateHeightOnComponentUpdate: false,
  hideCollapseHeight: false,
  animationDuration: 300,
  inlineReadMore: false,
};

Unveil.propTypes = {
  maxHeight: PropTypes.number,
  animateOpacity: PropTypes.bool,
  inlineReadMore: PropTypes.bool,
};

export default I18nHOC({ resource: "common" })(Unveil);
